import { put, takeLatest, call } from 'redux-saga/effects';
import STUDENT_CERT_TYPES from './_actionTypes';
import certificateHelper from '../../../utils/API/BackendHelper/admin/certificate';

function* handleFetchStudents(action) {
  try {
    const response = yield call(
      [certificateHelper, certificateHelper.getStudentsWithCertificates],
      action.payload
    );
    const { students, pagination } = response?.data ?? { students: [], pagination: {} };
    yield put({
      type: STUDENT_CERT_TYPES.FETCH_STUDENTS_SUCCESS,
      payload: { students, pagination },
    });
  } catch (error) {
    yield put({
      type: STUDENT_CERT_TYPES.FETCH_STUDENTS_FAILURE,
      payload: { error: error.message },
    });
  }
}

function* handleFetchStudentDetail(action) {
  try {
    const response = yield call(
      [certificateHelper, certificateHelper.getStudentCertificateDetail],
      action.payload.studentId
    );
    const data = response?.data;
    yield put({
      type: STUDENT_CERT_TYPES.FETCH_STUDENT_DETAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: STUDENT_CERT_TYPES.FETCH_STUDENT_DETAIL_FAILURE,
      payload: { error: error.message },
    });
  }
}

function* studentCertificatesSaga() {
  yield takeLatest(STUDENT_CERT_TYPES.FETCH_STUDENTS_REQUEST, handleFetchStudents);
  yield takeLatest(STUDENT_CERT_TYPES.FETCH_STUDENT_DETAIL_REQUEST, handleFetchStudentDetail);
}

export default studentCertificatesSaga;
